import React from 'react';
import UseCaseTemplate from '@/components/use-cases/UseCaseTemplate';

const summary = [
  'Govern brand trust consistently across every location',
  'Standardize responses and reporting across regions',
  'Spot location‑level risks before they spread'
];

const challenges = [
  {
    title: 'Fragmented ownership',
    description: 'Local teams respond differently, creating inconsistent brand perception.'
  },
  {
    title: 'Scale complexity',
    description: 'Hundreds of profiles and reviews make quality control difficult.'
  },
  {
    title: 'Regional visibility gaps',
    description: 'Performance varies widely by market without clear benchmarks.'
  }
];

const pillars = [
  {
    title: 'Governed Playbooks',
    description: 'Standard response rules and escalation paths for every location.'
  },
  {
    title: 'Location Intelligence',
    description: 'Track sentiment and performance by region, brand, and operator.'
  },
  {
    title: 'Leadership Reporting',
    description: 'Executive summaries with cross‑market comparisons and actions.'
  }
];

const timeline = [
  {
    title: 'Map',
    description: 'Audit all locations, listings, and review workflows.'
  },
  {
    title: 'Govern',
    description: 'Define response standards, escalation paths, and ownership.'
  },
  {
    title: 'Monitor',
    description: 'Track sentiment, rankings, and review velocity by location.'
  },
  {
    title: 'Optimise',
    description: 'Deliver regional action plans and executive reporting.'
  }
];

const deliverables = [
  'Multi‑location GBP governance',
  'Review response templates and escalation matrices',
  'Regional scorecards and dashboards',
  'Quarterly trust and visibility reviews'
];

const kpis = [
  'Standardized review response time across regions',
  'Reduced negative review impact by location',
  'Improved visibility in priority markets'
];

const example = {
  title: 'Example: 120‑location retail chain',
  result:
    'Centralized review governance reduced response times by 55% and improved average rating by 0.4 within two quarters.'
};

export default function Chains() {
  return (
    <UseCaseTemplate
      seoTitle="Use Case: Multi-Location Chains"
      seoDescription="Reputation and visibility governance for multi-location brands."
      path="/use-cases/chains"
      title="Multi-Location Chains"
      subtitle="We help chains control reputation, reviews, and AI visibility at scale."
      summary={summary}
      challenges={challenges}
      pillars={pillars}
      timeline={timeline}
      deliverables={deliverables}
      kpis={kpis}
      example={example}
    />
  );
}
